import { BETA_ENDS_AT } from '../data/beta.js';
/**
 * Whether an account was opened during the beta (ADR 0083). Read from the
 * account's creation date, never stored: the achievement that rewards the
 * testers is derived like every other one.
 */
export function isBetaAccount(accountCreatedAt, endsAt = BETA_ENDS_AT) {
    return endsAt === null || accountCreatedAt.getTime() < Date.parse(endsAt);
}
//# sourceMappingURL=beta.js.map